import React from "react";
import styles from "./VerticalTimeline.module.scss";
import { EMPTY_STRING } from "src/components/constant/constant";

type Subsection = {
  id: string;
  name: string;
};

type TimelineStep = {
  id: number;
  name: string;
  subsections: Subsection[];
};

type VerticalTimelineProps = {
  TimelineSteps: TimelineStep[];
  currentNode: number;
  currentSubsection: number;
  fillLevels: number[];
  lastNodeText?: string;
};

const VerticalTimeline: React.FC<VerticalTimelineProps> = ({
  TimelineSteps,
  currentNode,
  currentSubsection,
  fillLevels,
  lastNodeText
}) => {
  return (
    <div className={styles.sideBar}>
      {TimelineSteps.map((step, index) => (
        <div key={step.id} className={styles.thermometerSection} style={{ position: "relative" }}>
          <div className={`${styles.nodeCircle} ${index <= currentNode ? styles.active : EMPTY_STRING}`}></div>

          <div className={styles.thermometerFill} style={{ height: `${fillLevels[index]}%` }}></div>
          {index <= currentNode ? (
            <div className={styles.sectionLabelActive}>{step.name}</div>
          ) : (
            <div className={styles.sectionLabel}>{step.name}</div>
          )}
          {index === currentNode && currentSubsection >= 0 && (
            <div className={styles.subsectionLabelContainer}>
              <div className={styles.subsectionLabel}>
                {TimelineSteps[currentNode].subsections[currentSubsection]?.name}
              </div>
            </div>
          )}
          {index === TimelineSteps.length - 1 && (
            <div className={styles.lastSectionLabel} style={{ transform: lastNodeText && "translateX(-66%)" }}>
              {lastNodeText ?? "Order Card"}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default VerticalTimeline;
